import { render, staticRenderFns } from "./iconSvgJson.vue?vue&type=template&id=3831dc10&scoped=true&"
import script from "./iconSvgJson.vue?vue&type=script&lang=js&"
export * from "./iconSvgJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831dc10",
  null
  
)

export default component.exports